module.exports = require('crypto');


//////////////////
// WEBPACK FOOTER
// ./~/randomhex/src/crypto.js
// module id = 593
// module chunks = 0